import HttpClienteToken from '../../services/HttpClientToken';

import { AutoridadDomicilioProps, AutoridadProps } from '../../interfaces/catalogos/AutoridadInterface';
import { DomicilioProps } from '../../interfaces/comun/DomicilioInterface';

export const ObtenerAutoridades = () => {

    return new Promise<AutoridadProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Autoridad/ObtenerAutoridades/', token)
            .then( ({ data } : { data : AutoridadProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const Autoridades = () => {

    return new Promise<AutoridadProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/Autoridad/', token)
            .then( ({ data } : { data : AutoridadProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerAutoridadesMaterias = ( id: number ) => {

    return new Promise<AutoridadProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get(`/Api/Autoridad/ObtenerAutoridadesMaterias/${ id }`, token)
            .then( ({ data } : { data : AutoridadProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarAutoridad = ( params: AutoridadProps ) => {

    return new Promise<AutoridadProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Autoridad/Actualizar', params, token)
            .then( ({ data } : { data : AutoridadProps } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAutoridad: 0, 
                    referenciaPL: 0,
                    referenciaSAJI: 0,
                    descripcion: '',
                    idDomicilio: 0,
                    idMateria: 0,
                    idDistritoJudicial: 0,
                    activo: false,
                });
            });
        }

    });

}

export const AgregarAutoridad = ( params: AutoridadProps ) => {

    return new Promise<AutoridadProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Autoridad/Agregar', params, token)
            .then( ({ data } : { data : AutoridadProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idAutoridad: 0,
                    referenciaPL: 0,
                    referenciaSAJI: 0,
                    descripcion: '',
                    idDomicilio: 0,
                    idMateria: 0,
                    idDistritoJudicial: 0,
                    activo: false,
                });
            });
        }

    });

}

export const AgregarDomicilio = ( params: AutoridadDomicilioProps ) => {

    return new Promise<DomicilioProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/Autoridad/AgregarDomicilio', params, token)
            .then( ({ data } : { data : DomicilioProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idDomicilio: 0,
                    descripcion: '',
                    numero: "",
                    referencia: "",
                    idAsentamiento: 0,
                    idTipoDomicilio: 0,
                });
            });
        }

    });

}